module.exports = __webpack_public_path__ + "cdce3b3f5e78cd754e8c84fc38162905.jpg";